import styled from "styled-components";

/**
 * Wrapper do Dropdown (Mobile)
 * Estilização para exibir sugestões com transições suaves.
 */
export const DropdownWrapperMobile = styled.div.withConfig({
  shouldForwardProp: (prop) => !["isVisible"].includes(prop),
})<{ isVisible: boolean }>`
  background-color: ${({ theme }) => theme.colors.white};
  /* max-height: ${({ isVisible }) => (isVisible ? "100%" : "0")}; */
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  /* border-radius: ${({ theme }) => theme.borderRadius.medium}; */
  overflow: hidden;
  transition:
    max-height 0.3s ease-in-out,
    opacity 0.3s ease-in-out;
`;
